@if (isLoading) {
  <div class="spinner-border" role="status"></div>
}

@if (!isLoading) {
  <div>
    @if (tfaEnabled) {
      <div>
        <div class="card">
          <div class="alert alert-primary m-2" i18n>Zwei-Faktor-Authentifizierung ist aktiviert.</div>
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div i18n>QR Code</div>
              </div>
              <div class="col-sm-8">
                <!-- <qr-code [value]="qrInfo"></qr-code> -->
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-sm-4">
                <div i18n>Schlüssel:</div>
              </div>
              <div class="col-sm-8">
                <pre>{{ authenticatorKey }}</pre>
              </div>
            </div>
            <button class="btn btn-secondary" type="button" [asyncClick]="disableTfa" [disabled]="disableBtn.disabled" #disableBtn="asyncClick" i18n>
          @if (disableBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Zwei-Faktor-Authentifizierung deaktivieren
        </button>
          </div>
        </div>
      </div>
    }
    @if (!tfaEnabled) {
      <div>
        <div class="card">
          <div class="alert alert-danger m-2" i18n>
        Zwei-Faktor-Authentifizierung ist nicht aktiviert.
      </div>
        </div>
        <div class="card-body">
          <h2 i18n>Schritt 1</h2>
          <p i18n>Scannen Sie den folgenden QR-Code mit der Google Authenticator-App:</p>
          <!-- <qr-code [value]="qrInfo"></qr-code> -->
          <p i18n>
        Alternativ können Sie auch den folgenden Code in die Google Authenticator-App eingeben:
      </p>
          <pre>{{ authenticatorKey }}</pre>
        </div>
        <div class="card-body">
          <h2 i18n>Schritt 2</h2>
          <div>
            <form [formGroup]="tfaForm">
              <div class="mb-3 row">
                <label for="code" class="col-form-label" i18n
                  >Geben Sie hier den von der Google Authenticator-App bereitgestellten Code ein:</label
                  >
                  <div class="row">
                    <div class="col-sm-3">
                      <input type="text" id="code" formControlName="code" class="form-control" />
                    </div>
                    <div class="col-sm-9">
                      @if (validateControl('code') && hasError('code', 'required')) {
                        <em i18n
                          >Der Code ist ein Pflichtfeld</em
                          >
                        }
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn-secondary" [asyncClick]="enableTfa(tfaForm.value)" [disabled]="enableBtn.disabled || !tfaForm.valid" #enableBtn="asyncClick" i18n>
            @if (enableBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
            Zwei-Faktor-Authentifizierung aktivieren
          </button>
                </form>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <button class="btn btn-primary m-2" type="button" (click)="onBackClicked()" i18n>Zurück</button>
